module.exports = __webpack_public_path__ + "static/media/rm_06-17.31115e77.png";